import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeHelpArticleSkeleton } from './TypeHelpArticle'
import type { TypeHelpCategorySkeleton } from './TypeHelpCategory'

export interface TypeHelpNavFields {
  internalName: EntryFieldTypes.Symbol
  title: EntryFieldTypes.Symbol
  items: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeHelpArticleSkeleton | TypeHelpCategorySkeleton>>
  order: EntryFieldTypes.Integer
}

export type TypeHelpNavSkeleton = EntrySkeletonType<TypeHelpNavFields, 'helpNav'>
export type TypeHelpNav<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeHelpNavSkeleton,
  Modifiers,
  Locales
>

export function isTypeHelpNav<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeHelpNav<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'helpNav'
}
